import styled from "styled-components";
import { gBackground, mainColor, mainFont } from "../../styles/global";

export const WrapperHero = styled.div`
  padding: 4rem 7%;
  display: grid;
  place-items: center;
  gap: 9rem;
  grid-template-columns: 2.2fr 1.8fr;
  // grid-auto-flow:dense;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1rem 1rem;
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;
  }
`;
export const WrapperHeroTwo = styled.div`
  padding: 6rem 7%;
  margin-top: -50px;
  display: grid;
  place-items: center;
  gap: 9rem;
  grid-template-columns: 1.8fr 2.2fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 3rem 1rem 0 1rem;
    gap: 1rem;
  }
`;

export const WrapperHeroFour = styled.div`
  padding: 3rem 7%;
  backgroud: ${gBackground};
  display: flex;
  justify-content: center;
  gap: 0rem;
  margin: auto;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 1rem 1rem;
    // gap:2rem;
  }
`;
export const InvestImage = styled.img``;

export const TitleText = styled.div`
  margin-bottom: 50px;
  font-weight: bold;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
    margin-top: -20px;
    padding:0 1rem;
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 5px;
    .bodyTextAdjusted {
      margin: 10px;
      font-size:19px;
    }
    .smartSavings{
      margin: 0;
      font-size: 16px;
    }
  }
  .sublimeContainer{
    @media screen and (max-width: 640px){
      margin: 10px 55px;
      font-size: 21px;
    }
  }
  div {
    color: ${mainColor};
    font-family: ${mainFont};
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    line-height: 38px;
    letter-spacing: 0.01em;
    margin: 20px 0;
    @media screen and (max-width: 768px) {
      text-align: center;
      font-size: 1.1rem;
      line-height: 23px;
    }
  }
  h4 {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 38px;
    letter-spacing: 0.01em;
    color: #090458;
    margin: 20px 0;
    @media screen and (max-width: 768px) {
      text-align: center;
      font-size: 16px;
      margin: 10px 60px;
      line-height: 23px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  &:hover {
    transition: all ease-in-out 0.3s;
    transform: translateX(3px);
    cursor: pointer;
    opacity: 0.7;
  }
  @media screen and (max-width: 768px) {
    margin: auto;
    display: flex;
    justify-content: center;
  }
`;
